{
  "filter": {
    "all": "Todos os fornecedores",
    "country": "country",
    "direct": "Fornecedores diretos",
    "indirectConfidential": "Fornecedores indiretos, confidenciais",
    "nonConfidential": "Fornecedores indiretos, não confidenciais"
  },
  "list": {
    "countContact_one": "{{count}} Contato",
    "countContact_many": "countContact",
    "countContact_other": "{{count}} Contatos",
    "noAddress": "Nenhum endereço fornecido",
    "noSuppliers": "Nenhum fornecedor encontrado",
    "searchPlaceholder": "Buscar",
    "supplierTypePlaceholder": "Tipo de fornecedor"
  },
  "productionSites": {
    "columns": {
      "confidential": "Fornecedor confidencial",
      "contactEmail": "E-mail de contato",
      "country": "País",
      "internalCode": "Código interno",
      "name": "Nome",
      "parentCompany": "Parent business partner",
      "performedActivities": "Atividades realizadas",
      "registrationId": "IDs de registo do site"
    },
    "filters": {
      "searchPlaceholder": "Buscar"
    },
    "search": {
      "placeholder": "Buscar"
    },
    "title": "Locais de produção"
  },
  "repository": {
    "actions": {
      "delete": "Eliminar",
      "edit": "Editar"
    },
    "create": {
      "error": {
        "message": "The business partner has not been created",
        "title": "Error creating business partner"
      },
      "success": {
        "message": "The business partner has been created successfully",
        "title": "Business partner created"
      }
    },
    "delete": {
      "error": {
        "message": "The business partner has not been deleted",
        "title": "Error deleting business partner"
      },
      "success": {
        "message": "The business partner has been deleted successfully",
        "title": "Business partner deleted"
      }
    },
    "title": "All",
    "update": {
      "error": {
        "message": "The business partner has not been updated",
        "title": "Error updating business partner"
      },
      "success": {
        "message": "The business partner has been updated successfully",
        "title": "Business partner updated"
      }
    }
  },
  "risk": {
    "high": "Alto",
    "low": "Baixo",
    "medium": "Médio",
    "table": {
      "certificationRisk": {
        "title": "title",
        "tooltip": "tooltip"
      },
      "collaborationRisk": {
        "title": "title",
        "tooltip": "tooltip"
      }
    }
  },
  "sort": {
    "averageResponseTime": "averageResponseTime",
    "company": "company",
    "completedProductionSiterequests": "completedProductionSiterequests",
    "completedProductrequests": "completedProductrequests",
    "completedScopeCertificaterequests": "completedScopeCertificaterequests",
    "completedTransactionCertificaterequests": "completedTransactionCertificaterequests",
    "email": "email",
    "lastConnectionDate": "lastConnectionDate",
    "lastReminderDate": "lastReminderDate",
    "name": "name",
    "pendingDocumentrequests": "pendingDocumentrequests",
    "pendingProductionSiterequests": "pendingProductionSiterequests",
    "pendingProductrequests": "pendingProductrequests",
    "pendingScopeCertificaterequests": "pendingScopeCertificaterequests",
    "pendingTransactionCertificaterequests": "pendingTransactionCertificaterequests"
  },
  "subSuppliers": {
    "title": "Meus fornecedores"
  },
  "supplier": {
    "averageResponseTime": "Tempo médio de resposta",
    "averageResponseTimeValue_one": "{{nbDays}} dia",
    "averageResponseTimeValue_many": "{{nbDays}} dias",
    "averageResponseTimeValue_other": "{{nbDays}} dias",
    "informationRequests": "Pedidos de informações do produto",
    "lastConnection": "Última conexão",
    "lastConnectionValue": "Há {{nbDays}} dias",
    "lastReminderSent": "Último e-mail enviado",
    "lastReminderSentValue": "Há {{nbDays}} dias",
    "noLastConnection": "Ainda sem conexão",
    "noLastReminderSent": "Ainda sem e-mail enviado",
    "noResponseTime": "Ainda sem resposta",
    "productionSites": "Locais de produção",
    "scopeCertificates": "Certificados de escopo",
    "transactionCertificates": "Certificados de transação",
    "transferContact_one": "Transferir {{count}} solicitação incompleta\npara outro contato",
    "transferContact_many": "transferContact",
    "transferContact_other": "Transferir {{count}} solicitações incompletas\npara outro contato",
    "transferContactCertificates_one": "transferContactCertificates",
    "transferContactCertificates_many": "transferContactCertificates",
    "transferContactCertificates_other": "transferContactCertificates",
    "transferModal": {
      "companyCountry": "companyCountry",
      "companyCountryPlaceholder": "companyCountryPlaceholder",
      "companyName": "companyName",
      "companyNamePlaceholder": "companyNamePlaceholder",
      "email": "E-mail",
      "emailPlaceholder": "por exemplo: joao@empresa.com",
      "name": "Nome",
      "namePlaceholder": "por exemplo: João Silva",
      "title": "Transferir contato",
      "transfer": "Transferir",
      "transferSuccess_one": "transferSuccess",
      "transferSuccess_many": "transferSuccess",
      "transferSuccess_other": "transferSuccess"
    }
  },
  "title": "Fornecedores comerciais"
}
